import React from "react";
import { Redirect } from "react-router-dom";

export const Home = () => {
  // return <h2>Home</h2>;
  return <Redirect to={`/login`}></Redirect>;
};
